import { parse } from "date-fns"

export type FinancialYearRange = {
  startDate: Date
  endDate: Date
}

/**
 * Returns the Australian financial year (1 Jul to 30 Jun) containing the given date.
 * Pure helper for cut-off utilities that must run outside the browser test runtime.
 */
export function financialYearForDate(date: Date): FinancialYearRange {
  const year = date.getFullYear()
  const month = date.getMonth() + 1

  if (month > 6) {
    return {
      startDate: parse(`${year}-07-01 00:00:00`, "yyyy-MM-dd HH:mm:ss", date),
      endDate: parse(`${year + 1}-06-30 23:59:59`, "yyyy-MM-dd HH:mm:ss", date),
    }
  }

  return {
    startDate: parse(`${year - 1}-07-01 00:00:00`, "yyyy-MM-dd HH:mm:ss", date),
    endDate: parse(`${year}-06-30 23:59:59`, "yyyy-MM-dd HH:mm:ss", date),
  }
}
